/* import countries from 'https://restcountries.eu/rest/v2/all?fields=alpha2Code;name;flag;currencies;timezones;callingCodes;languages'

const state = () => ({
  all: []
})

const getters = {}

const actions = {}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} */
export default {
   namespaced: true,
   state() {
       return {
         countries: [
          {
            code: "br",
            name: "Brazil",
            lang: "pt",
            gmt: "-3",
          },
          {
            code: "kh",
            name: "Cambodia",
            lang: "km",
            gmt: "+7",
          },
          {
            code: "cn",
            name: "China",
            lang: "zh",
            gmt: "+8",
          },
          {
            code: "id",
            name: "Indonesia",
            lang: "id",
            gmt: "+7",
          },
          {
            code: "jp",
            name: "Japan",
            lang: "ja",
            gmt: "+9",
          },
          {
            code: "kr",
            name: "Korea",
            lang: "ko",
            gmt: "+9",
          },
          {
            code: "my",
            name: "Malaysia",
            lang: "zh",
            gmt: "+8",
          },
          {
            code: "th",
            name: "Thailand",
            lang: "th",
            gmt: "+7",
          },
          {
            code: "uk",
            name: "United Kingdom",
            lang: "en",
            gmt: "+0",
          },
          {
            code: "vn",
            name: "Vietnam",
            lang: "vi",
            gmt: "+7",
          },
        ],
       }
   },
   getters: {
      countries(state){
        return state.countries
      },
    },
    mutations: {},
    actions: {},
    modules: {},
}